import { database } from "../firebase/config";
import {
  collection,
  doc,
  setDoc,
  getDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  onSnapshot,
  query,
  where,
  orderBy,
} from "firebase/firestore";

const EVENTS_COLLECTION = "events";

export const eventService = {
  async getEvent(key) {
    const ref = doc(database, EVENTS_COLLECTION, key);
    const snap = await getDoc(ref);
    return snap.exists() ? snap.data() : null;
  },

  subscribeToEvent(key, callback, onError) {
    const ref = doc(database, EVENTS_COLLECTION, key);
    return onSnapshot(
      ref,
      (snap) => {
        callback(snap.exists() ? snap.data() : null);
      },
      (e) => {
        if (onError) onError(e);
      },
    );
  },

  async getAllEvents() {
    const q = query(
      collection(database, EVENTS_COLLECTION),
      orderBy("createdAt", "desc"),
    );
    const qs = await getDocs(q);
    const items = [];
    qs.forEach((d) => items.push(d.data()));
    return items;
  },

  async listPublishedEvents() {
    const q = query(
      collection(database, EVENTS_COLLECTION),
      where("status", "==", "published"),
      orderBy("createdAt", "desc"),
    );
    const qs = await getDocs(q);
    const items = [];
    qs.forEach((d) => items.push(d.data()));
    return items;
  },

  subscribeToAllEvents(callback, onError) {
    const q = query(
      collection(database, EVENTS_COLLECTION),
      orderBy("createdAt", "desc"),
    );
    return onSnapshot(
      q,
      (qs) => {
        const items = [];
        qs.forEach((d) => items.push(d.data()));
        callback(items);
      },
      (e) => {
        if (onError) onError(e);
      },
    );
  },

  subscribeToPublishedEvents(callback, onError) {
    const q = query(
      collection(database, EVENTS_COLLECTION),
      where("status", "==", "published"),
      orderBy("createdAt", "desc"),
    );
    return onSnapshot(
      q,
      (qs) => {
        const items = [];
        qs.forEach((d) => items.push(d.data()));
        callback(items);
      },
      (e) => {
        if (onError) onError(e);
      },
    );
  },

  async createEvent({ key, title, subtitle, meta = {} }) {
    if (!key || !title) throw new Error("key e title sono obbligatori");
    const ref = doc(database, EVENTS_COLLECTION, key);
    const existing = await getDoc(ref);
    if (existing.exists()) {
      throw new Error("Esiste già un evento con questa key");
    }
    const now = new Date();
    const data = {
      key,
      title,
      subtitle: subtitle || "",
      status: "draft",
      createdAt: now,
      updatedAt: now,
      meta,
    };
    await setDoc(ref, data);
    return data;
  },

  async updateEvent(key, fields) {
    if (!key) throw new Error("key obbligatoria");
    const ref = doc(database, EVENTS_COLLECTION, key);
    const payload = { ...fields, updatedAt: new Date() };
    await updateDoc(ref, payload);
    const snap = await getDoc(ref);
    return snap.data();
  },

  async publishEvent(key) {
    return this.updateEvent(key, { status: "published" });
  },

  async unpublishEvent(key) {
    return this.updateEvent(key, { status: "draft" });
  },

  async deleteEvent(key) {
    const ref = doc(database, EVENTS_COLLECTION, key);
    await deleteDoc(ref);
    return true;
  },
};
